/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/
/*
function sampleData(){
    var samples = sessionStorage.getItem('samples');
    if(samples){
        var data = samples.split(',');
      for(i=0;i<data.length;i++){
        //console.log(data[i]);
          $("[data-sku='" + data[i] + "']").attr('disabled', true).text('Sample Added');
      }
    }
  }
function checkCartSmples(){
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart){
        //console.log(cart);
        var samples = 0;
        var samplesData = [];
        if(cart.items.length){
          for (i=0;i<cart.items.length;i++){
          	var id = cart.items[i].id;
            if (id == 43089714249963){
              samples++;
              samplesData.push(cart.items[i].properties.SKU);
            }
          }
        }
        sessionStorage.setItem('samples', samplesData.join(','));
        sampleData();
        if (samples >= 5){
        	$('.product-get-sample').attr('disabled', true);
        }else{
        	//console.log(samples);
        }
        
      }
    });
}

checkCartSmples();

$('body').on('click','.product-get-sample',function(){
    var sampleBtn = $(this);
	var name = sampleBtn.data('name');
    var sku = sampleBtn.data('sku');
    var sample = sampleBtn.data('sample');
    
    sampleBtn.addClass('in');
  
	$.ajax({
      type: 'post',
      url: '/cart/add.js',
      data: {
        items: [
          {
            quantity: 1,
            id: sample,
            properties: {
              'Product': name,
              'SKU': sku
            }
          }
        ]
      },
      success: function(cart){
        //console.log(cart.items);
        if (cart.items[0].quantity >1){
          jQuery.post('/cart/change.js', { id: sample, line: 1 });
        }
        sampleBtn.removeClass('in').attr('disabled', true).text('Sample Added');
        checkCartSmples();
      },
      dataType: 'json'
    });
  	
});
*/

$(document).ready(function () {
  if ($('.filter-checkbox').length) {
    $('.filter-checkbox').on('change', function () {
      $(this).closest('form').submit();
    });
  }
  if ($('.tag-filter').length) {
    /* WOMF fix (Sep 2026): this block appended window.location.search to every
       .tag-filter href, and a SECOND block below did it again for
       .active-filters .tag-filter (a subset of the same elements). Filter
       hrefs therefore accumulated ?page=3?page=3... Every click minted a new
       URL, which is how Search Console reached 557,000 known URLs and 17,499
       soft 404s.
       Now: drop `page` (a filter click must reset to page 1), keep the other
       params (sort_by etc.), and never append to an href that already carries
       a query string. The second block is gone -- .active-filters .tag-filter
       is matched by the .tag-filter selector already. */
    var collQuery = '';
    try {
      var params = new URLSearchParams(window.location.search);
      params.delete('page');
      var qs = params.toString();
      collQuery = qs ? '?' + qs : '';
    } catch (e) {
      collQuery = '';
    }
    if (collQuery) {
      $('.tag-filter').each(function () {
        var href = $(this).attr('href') || '';
        if (href.indexOf('?') === -1) {
          $(this).attr('href', href + collQuery);
        }
      });
    }
  }
});
document.querySelectorAll("a[href=\"#open-chat\"]").forEach(function (link) {
  link.addEventListener('click', function (event) {
    event.preventDefault();
    document.getElementById('dummy-chat-button-iframe').contentDocument.querySelector('.chat-toggle').click();
  });
});
/******/ })()
;